import { render } from "./UnCryptoGroupBuyDealBanner.vue?vue&type=template&id=151ca42e&scoped=true"
import script from "./UnCryptoGroupBuyDealBanner.vue?vue&type=script&lang=js"
export * from "./UnCryptoGroupBuyDealBanner.vue?vue&type=script&lang=js"

import "./UnCryptoGroupBuyDealBanner.vue?vue&type=style&index=0&id=151ca42e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151ca42e"]])

export default __exports__